import ChartGroupingLevelSelectorFillingStrategy from './ChartGroupingLevelSelectorFillingStrategy'

function UsersGroupsGroupingLevelSelectorFillingStrategy() {}

UsersGroupsGroupingLevelSelectorFillingStrategy.prototype = new ChartGroupingLevelSelectorFillingStrategy();

UsersGroupsGroupingLevelSelectorFillingStrategy.prototype.fillGroupingLevelListSelector = function( listSelector )
{
    this.addUsersItem( listSelector );
    this.addUserGroupsItemIfNeeded( listSelector );
    this.addTimeZoneGroupsItemIfNeeded( listSelector );
};

export default UsersGroupsGroupingLevelSelectorFillingStrategy


// WEBPACK FOOTER //
// ./web/js/reports/charts/UsersGroupsGroupingLevelSelectorFillingStrategy.js